"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getResource = exports.oDataResource = void 0;
var metadata = [];
function oDataResource(resource) {
    return function (target) {
        var existing = metadata.find(function (m, _) { return m.type === target; });
        if (existing) {
            existing.resource = resource;
        }
        else {
            metadata.push({ type: target, resource: resource });
        }
    };
}
exports.oDataResource = oDataResource;
function getResource(type) {
    var existing = metadata.find(function (m, _) { return m.type === type; });
    return (existing && existing.resource) || null;
}
exports.getResource = getResource;
//# sourceMappingURL=decorators.js.map